// extracted by mini-css-extract-plugin
module.exports = {"root":"Backdrop_root__7TAdn"};